import React, {useState} from 'react'
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'
import IconButton from "@material-ui/core/IconButton";
import Button from '@material-ui/core/Button'
import Fab from '@material-ui/core/Fab'

import plLocale from 'date-fns/locale/pl'
import enLocale from 'date-fns/locale/en-US'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faEraser, faShoppingCart} from '@fortawesome/free-solid-svg-icons'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { faFilter } from '@fortawesome/free-solid-svg-icons'

import {_t} from './../../../i18n/lang'

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';


const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '30ch',
        },
        '& .MuiInputBase-input': {
            height: '1.8em'
        },
    },
    fabStyle: {
        marginRight: '1em',
        backgroundColor: '#cb0101'
    },
    headerColor: {
        color: '#cb0101',
    }
}));

export default function Filter(props) {
    const classes = useStyles();
    const [filters, setFilters] = useState({
        phrase: '',
        startFrom: null,
        startTo: null,
        expireFrom: null,
        expireTo: null,
    })
    const { setParentFilters } = props

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFilters((prevState) => {
            const newValue = { ...prevState, [name]: value }
            setParentFilters(newValue)
            return newValue
        });
    }

    const handleDateChange = (name, value) => {
        setFilters((prevState) => {
            const newValue = { ...prevState, [name]: value }
            setParentFilters(newValue)
            return newValue
        });
    }

    const clearFilter = () => {
        const filtersValue = {
            phrase: '',
            startFrom: null,
            startTo: null,
            expireFrom: null,
            expireTo: null
        }
        setParentFilters(filtersValue)
        setFilters(filtersValue)
    }

    return (
        <>
            <h1 className={classes.headerColor}>
                <Fab aria-label="cart" color="secondary" size="medium" className={classes.fabStyle}>
                    <FontAwesomeIcon icon={faFilter}  />
                </Fab>
                {_t('PP_FILTER_HEADER')}
            </h1>

            <form className={classes.root} noValidate autoComplete="off" >
                <TextField
                    label={_t('PP_FILTER_START_PHRASE')}
                    name='phrase'
                    value={filters.phrase}
                    onChange={handleChange}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton>
                                    <FontAwesomeIcon size='xs' icon={faSearch} />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />

                <div style={{textAlign: 'right', paddingTop: '1em', width: '100%'}}>
                    <Button
                        variant="contained"
                        size="small"
                        startIcon={<FontAwesomeIcon icon={faEraser} />}
                        onClick={clearFilter}
                        style={{
                            marginRight: '5.3em',
                            backgroundColor: '#cb0101',
                            color: '#fff'
                        }}
                    >
                        {_t('PP_FILTER_BUTTON_CLEAR')}
                    </Button>
                </div>
            </form>
        </>
    )
}
